<template>
    <main class="page__content">
        <div class="plain-content">
            <div class="plain-content__inner">
                <div class="plain-content__header">
                    <h1>Barrierefreiheitserklärung</h1>
                </div>
                <div class="plain-content__body">
                    <p>Stadtwerke Velbert GmbH setzt sich dafür ein, die digitale Barrierefreiheit für Menschen mit Behinderungen zu
                        gewährleisten. Wir verbessern kontinuierlich die Benutzerfreundlichkeit für alle und wenden die entsprechenden
                        Standards (WCAG 2.2, BITV und der Norm EN 301 549) für die Zugänglichkeit an. Diese Erklärung zur digitalen
                        Barrierefreiheit gilt für die unter www.velbert-zeigt-herz.de veröffentlichten Webseite der Stadtwerke
                        Velbert GmbH.
                    </p>
                    <h2 class="h5">Stand der Vereinbarkeit mit den Anforderungen</h2>

                    <p>Der Webauftritt ist mit den technischen Anforderungen gemäß der Web Content Accessibility Guidelines (WCAG) 2.2 und
                        der Barrierefreie-Informationstechnik-Verordnung (BITV 2.0) derzeit vereinbar.
                        <br>Diese Erklärung wurde am <b>23.06.2025</b> erstellt. Die Erklärung wurde mithilfe der Eye-Able® Technologie der
                        <b>Web Inclusion GmbH</b> erstellt.
                        Mehr Informationen zur Web Inclusion GmbH sind unter <a href="https://eye-able.com/" target="_blank">eye-able.com</a> zu finden. Die Web Inclusion GmbH hat
                        alle maschinell überprüfbaren Prüfschritte durchlaufen.
                    </p>
                    <h2 class="h5">Rückmeldung und Kontaktangaben</h2>

                    <p>Sie haben eine Anmerkung oder einen Hinweis zu Barrieren auf dieser Webseite? Bitte nehmen Sie mit uns Kontakt auf.
                        Wir erklären Ihnen, welche Barrieren bestehen. Sie können sich informieren, welche Ausnahmen wir gemacht haben.
                        Wir beantworten Ihre Fragen schnellstmöglich, spätestens jedoch innerhalb der gesetzlichen Frist von sechs Wochen.
                        Vielen Dank für Ihr Feedback.
                        Sie können uns über folgende Adresse kontaktieren: <br><br>
                        Gesa Walther<br>Kettwiger Str. 2<br> 42549 Velbert<br><a
                            href="mailto:marketing@stwvelbert.de">marketing@stwvelbert.de</a><br>02051988601
                    </p>
                    <h2 class="h5">Schlichtungsstelle</h2>

                    <p>Schlichtungsstelle nach dem Behindertengleichstellungsgesetz bei dem Beauftragten der Bundesregierung für die Belange
                        von Menschen mit Behinderungen
                        <br>Mauerstraße 53 <br>10117 Berlin <br><a
                            href="mailto:info@schlichtungsstelle-bgg.de ">info@schlichtungsstelle-bgg.de </a> <br>030185272805
                        <br><a target="_blank" href="https://www.schlichtungsstelle-bgg.de">www.schlichtungsstelle-bgg.de</a>
                        <br>Hinweis zu § 36 VSBG: Wir nehmen an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
                        nicht teil und sind dazu auch nicht verpflichtet.
                    </p>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    name: 'PageAccessibilityStatement'
}
</script>



// WEBPACK FOOTER //
// src/components/PageAccessibilityStatement.vue